export const PIXEL_ID = '1395671338234046'

export const initPixel = () => {
  if (typeof window === 'undefined') return

  // Initialize Facebook Pixel
  !function(f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
    if (f.fbq) return;
    n = f.fbq = function() {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s)
  }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

  // @ts-ignore
  window.fbq('init', PIXEL_ID)
}

export const trackPageView = () => {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    // @ts-ignore
    window.fbq('track', 'PageView')
  }
}

// https://developers.facebook.com/docs/facebook-pixel/reference#standard-events
export const trackEvent = (name: string, options = {}) => {
  if (typeof window !== 'undefined') {
    if ((window as any).fbq) {
      console.log(`[Meta Pixel] Tracking ${name}:`, options)
      // @ts-ignore
      window.fbq('track', name, options)
    } else {
      console.warn(`[Meta Pixel] fbq not defined when trying to track ${name}`)
    }
  }
}

export const trackCustomEvent = (name: string, options = {}) => {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    // @ts-ignore
    window.fbq('trackCustom', name, options)
  }
}
